module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-05-8a52e8ab6e1eca1b074699ed9e5e42cb.png";